<div>
  <app-form-group label="Id">
    <input disabled required class="form-control" [(ngModel)]="transferPoint.pilotTransferPointId">
  </app-form-group>
  <app-form-group label="Name">
    <input required class="form-control" [(ngModel)]="transferPoint.name" (ngModelChange)="onUpdate()">
  </app-form-group>
  <app-form-group label="Next Pilot transfer points">
    <app-multiselect [(ngModel)]="nextTransferPoints" [optionsProvider]="allPilotTransferPoints"
                     [formatter]="pilotTransferPointFormatter" (ngModelChange)="setNextTransferPoints($event)"
                     dataKey="pilotTransferPointId">
    </app-multiselect>
  </app-form-group>
</div>
